import React from 'react';
import PropTypes from 'prop-types';

import Modal from '../Modal';
import { Tabs, TabList, Tab, TabPanel, TabPanels } from '../Tabs';

import styles from './styles.module.scss';

//
// ModalTabs
// --------------------

export function ModalTabs({ className, children, ...otherProps }) {
  const classNames = [styles.tabs];
  if (className) {
    classNames.push(className);
  }
  return (
    <Tabs className={classNames.join(' ')} {...otherProps}>
      {children}
    </Tabs>
  );
}

ModalTabs.defaultProps = {
  className: null
};

ModalTabs.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string
};

//
// ModalTabList
// --------------------

export function ModalTabList({ className, children }) {
  const classNames = [styles.tabList];
  if (className) {
    classNames.push(className);
  }
  return <TabList className={classNames.join(' ')}>{children}</TabList>;
}

ModalTabList.defaultProps = {
  className: null
};

ModalTabList.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string
};

//
// ModalTab
// --------------------

export function ModalTab({ className, children, disabled }) {
  const classNames = [styles.tab];
  if (className) {
    classNames.push(className);
  }
  return (
    <Tab className={classNames.join(' ')} disabled={disabled}>
      {children}
    </Tab>
  );
}

ModalTab.defaultProps = {
  className: null,
  disabled: false
};

ModalTab.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  disabled: PropTypes.bool
};

//
// ModalTabPanels
// --------------------

export function ModalTabPanels({ className, children }) {
  const classNames = [styles.tabPanels];
  if (className) {
    classNames.push(className);
  }
  return <TabPanels className={classNames.join(' ')}>{children}</TabPanels>;
}

ModalTabPanels.defaultProps = {
  className: null
};

ModalTabPanels.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string
};

//
// ModalTabPanels
// --------------------

export function ModalTabPanel({ className, children }) {
  const classNames = [styles.tabPanel];
  if (className) {
    classNames.push(className);
  }
  return <TabPanel className={classNames.join(' ')}>{children}</TabPanel>;
}

ModalTabPanel.defaultProps = {
  className: null
};

ModalTabPanel.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string
};

//
// ModalWithTabs
// --------------------

export default function ModalWithTabs({
  isOpen,
  className,
  onDismiss,
  children,
  title,
  logo,
  ...otherProps
}) {
  const classNames = [styles.dialog];
  if (className) {
    classNames.push(className);
  }
  return (
    <Modal
      isOpen={isOpen}
      className={classNames.join(' ')}
      onDismiss={onDismiss}
      hasClose={true}
      {...otherProps}
    >
      <div className={styles.header}>
        <div className={styles.headerContent}>
          <h2 className={styles.headerTitle}>
            {logo && <img src={logo} alt="" className={styles.logo} />}
            {title}
          </h2>
        </div>
      </div>
      {children}
    </Modal>
  );
}

ModalWithTabs.defaultProps = {
  isOpen: false,
  className: null,
  onDismiss: () => {},
  logo: null
};

ModalWithTabs.propTypes = {
  children: PropTypes.node.isRequired,
  title: PropTypes.node.isRequired,
  logo: PropTypes.string,
  isOpen: PropTypes.bool,
  className: PropTypes.string,
  onDismiss: PropTypes.func
};
